import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Phone20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.41127 2.52181L7.41221 2.52415L9.00218 6.52409C9.17665 6.96297 9.07325 7.49048 8.74593 7.83097L8.74031 7.83681L7.32691 9.27554C7.62933 11.003 9.11343 12.6464 10.8911 12.8753C11.3702 12.3981 11.8448 11.9161 12.3255 11.4405C12.666 11.1132 13.1934 11.0098 13.6323 11.1842L17.6346 12.7752C18.2825 13.0353 18.5755 13.7958 18.2951 14.4283C17.4736 16.1053 16.0387 17.4398 14.3016 18.1284L14.2785 18.1376L14.2548 18.1452C10.9794 19.1984 7.38862 17.3842 5.11927 15.0658C4.14163 14.067 3.11215 12.675 2.45249 11.1041C1.79304 9.53371 1.47962 7.72389 2.03992 5.94579C2.59855 4.17296 4.10418 2.63635 5.77127 1.85556C6.39902 1.57724 7.15546 1.88454 7.41127 2.52181ZM6.13014 3.35963L7.54332 6.91478L5.75587 8.73434C5.89923 10.2572 6.4344 11.6569 7.56892 12.7264C8.54666 13.8071 10.2667 14.7438 11.7056 14.1815C12.2137 13.6734 12.7349 13.1607 13.2448 12.6444L16.7979 14.0567C16.127 15.2645 15.0597 16.2081 13.7722 16.7247C11.0574 17.5818 8.04887 15.9144 6.19122 14.0166C4.33537 12.1206 2.6185 9.14997 3.46344 6.41944C3.97311 5.11932 4.917 4.03926 6.13014 3.35963Z'
      fill='currentColor'
    />
  </Svg>
);

Phone20.displayName = 'Phone20';
export default Phone20;
